import CommercialRulesContainer from './CommercialRulesContainer'

export default function CommercialRulesScreen() {
    return <CommercialRulesContainer />
}
